import React from 'react';
import whiteLogo from '../../assets/images/white-logo.svg';
import styles from './LearnFooter.module.scss';
import White_Logo from '../../assets/images/WhiteLogo.svg';
import { Grid, Stack, Box } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import useDesktopCheck from '../../helpers/hooks/useDesktopCheck'
import SmallPhone from '../../assets/images/SmallPhone.svg';
import SmallMail from '../../assets/images/SmallMail.svg';

export const LearnFooter: React.FC = () => {
const isDesktop = useDesktopCheck();

return<>
<Grid container px={3.75} py={3.75}
 sx={{
  color:'white',
  background:'#080A2D',
  height:{ xs: 191, sm: 250},
  borderBottom: '1px solid white',
  alignItems:{
   sm:'center',
}}}>
    <Grid item xs={12} sm={6}>
      <img {...(isDesktop?{height:90,width:700}:{})} src={White_Logo} alt="logo"/>
</Grid>
<Grid item xs={12} sm={6}>
<Stack direction="row"
spacing={2}
sx={{display:{
  sm:'flex'
},
justifyContent:{sm:'flex-end'},marginTop:{sm:'45px'}}}>
  <a href="https://www.linkedin.com/company/10347780" style={{color: 'inherit', textDecoration: 'none !important'}}><LinkedInIcon /></a>
  <a href="https://twitter.com/The_Guarantors" style={{color: 'inherit', textDecoration: 'none !important'}}><TwitterIcon/></a>
  <a href="https://www.facebook.com/TheGuarantors" style={{color: 'inherit', textDecoration: 'none !important'}}><FacebookIcon/></a>
  <a href="https://www.instagram.com/theguarantors" style={{color: 'inherit', textDecoration: 'none !important'}}><InstagramIcon/></a>
</Stack>
</Grid>
</Grid>
<Grid container px={3.75} sx={{color:'white', background:'#080A2D', fontSize:'16px'}}>
<Grid item xs={12} sx={{opacity:.5}} mt={5}>
<img src={SmallPhone} alt=''/> (212) 266-0020
<img src={SmallMail} className='ml-5' alt=''/> success@theguarantors.com
</Grid>
<Grid item xs={12} sm={4} sx={{opacity:.5}} mt={5}>
TheGuarantors is a licensed insurance agent and broker. For more detailed information, please see our <a href="https://www.theguarantors.com/legal-regulatory?hsLang=en" style={{ color: 'inherit' }}>Legal/Regulatory Notice</a>.
</Grid>
<Grid item xs={12} sx={{opacity:.5}} mt={3} container display="flex" justifyContent='space-between'>
  <Grid item md={3} sx={{display:{md:'block',xs:'none'}}} xs={12} mb={2}>© 2023 TheGuarantors</Grid>
  <Grid container md={7} spacing={2} display='flex' justifyContent="flex-end">
  <Grid item md={2} xs={7} mb={2}><a href="https://www.theguarantors.com/privacy?hsLang=en" style={{ color: 'inherit', textDecoration: 'none' }}>Privacy Policy</a></Grid>
  <Grid item md={2.5} xs={5} mb={2}><a href="https://www.theguarantors.com/terms?hsLang=en" style={{ color: 'inherit', textDecoration: 'none' }}>Terms of Service</a></Grid>
  <Grid item md={3.5} xs={7} mb={2}><a href="https://www.theguarantors.com/legal-regulatory?hsLang=en" style={{ color: 'inherit', textDecoration: 'none' }}>Legal/Regulatory Notice </a></Grid>
  <Grid item md={2} xs={5} mb={2}><a href="https://www.rebny.com/" style={{ color: 'inherit', textDecoration: 'none' }}>Member RBNY</a></Grid>
  </Grid>
</Grid>
<Grid container>
<Grid item sx={{display:{md:'none'}}} xs={12} mb={2}>© 2023 TheGuarantors</Grid>
</Grid>

</Grid></>

  return (
    <div className={styles.footer_container}>
      <Box className={styles.footer_main}>
        <Box className={styles.footer_section_l}>
          <>
            <div>
              <a
                href="https://www.theguarantors.com/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={whiteLogo} alt="" />
              </a>
            </div>
            <p className={styles.companyinfo}>
              We are a fintech company that is rethinking financial and
              insurance solutions for residential real estate professionals as
              well as their residents.
            </p>
            <div className={styles.companymail}> RI@TheGuarantors.com</div>
            <p className={styles.companyaddress}>
              1 World Trade Center New York, NY 10007
            </p>
          </>
        </Box>
        <Box className={styles.footer_section_r}>
          <div className={styles.quick_links}>
            <a href="https://www.theguarantors.com/terms?hsLang=en">
              Terms of Service
            </a>
            <a href="https://www.theguarantors.com/privacy?hsLang=en">
              Privacy Policy
            </a>
            <a href="https://www.theguarantors.com/legal-regulatory?hsLang=en">
              Licencing
            </a>
          </div>
        </Box>
      </Box>
    </div>
  );
};

